/**
 * Utility functions for permission checking
 */

// Check if user has permission for a specific resource and action
const hasPermission = (permissions, resource, action) => {
  if (
    !permissions ||
    !permissions.byResource ||
    !Array.isArray(permissions.byResource[resource])
  ) {
    return false;
  }
  return permissions.byResource[resource].includes(action);
};

// Check if user has ANY of the specified permissions
export const hasAnyPermission = (permissions, permissionChecks) => {
  return permissionChecks.some(([resource, action]) =>
    hasPermission(permissions, resource, action)
  );
};

// Check if user has ALL of the specified permissions
export const hasAllPermissions = (permissions, permissionChecks) => {
  return permissionChecks.every(([resource, action]) =>
    hasPermission(permissions, resource, action)
  );
};

// Check if the current route should be accessible
export const isRouteAccessible = (permissions, requiredPermission) => {
  if (!requiredPermission) return true; // No permission required
  if (Array.isArray(requiredPermission[0])) {
    return hasAllPermissions(permissions, requiredPermission);
  }
  const [resource, action] = requiredPermission;
  return hasPermission(permissions, resource, action);
};
